import "./MenuVtc.css";
import { manualdownload } from "../../../Api/SubUrl";
import { Path } from "../../../Api/Path";
function MenuVTC() {

  return (
    <div className="content-right">
      <div className="inner">
        <a
          href={manualdownload}
          className="download"
          aria-label="Tải xuống"
          rel="noopener noreferrer"
        ></a>

        <a
          href={Path.Group}
          className="trade"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Group"
        ></a>

        <a
          href={Path.Fanpage}
          className="fanpage"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="fanpage"
        ></a>

        <a
          href={Path.ZaloSupportGroupUrl}
          className="group"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Zalo Support Group"
        ></a>

        <button
          type="button"
          className="totop"
          id="totop"
          aria-label="Lên đầu trang"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        ></button>
      </div>
    </div>
  );
}
export default MenuVTC;
